<template>
<div>
	<div class="row">

		<div class="col-12">
			<partial-loader :loading="isFetching"></partial-loader>
		</div>

		<div class="col-12"
		     v-if="!isFetching">

			<h2 class="display-4">{{ $t('sellerCost.sellerCost') }}</h2>

			<p>
				{{ $t('sellerCost.itemsCount') }}: {{ costs.item_count }}
			</p>

			<b-alert v-if="error"
			         variant="danger"
			         show>{{ error }}</b-alert>

			<b-alert v-if="formError"
			         show
			         variant="warning">
				<span v-for="(errors, i) in formError.errors" :key="i">
						<span v-for="(error, j) in errors" :key="`${i}-${j}`">{{ error }}<br /></span>
				</span>
			</b-alert>
			<b-form @submit.prevent="save">

				<div class="row mb-2">
					<div class="col">{{ $t('sellerCost.transportCost') }}</div>
					<div class="col-lg-4 col-md-6 col-sm-12">
						<b-input-group>
							<b-input-group-prepend is-text><i class="fas fa-euro-sign fa-fw"></i></b-input-group-prepend>
							<b-form-input type="number"
							              step="any"
							              class="text-right"
										  autocomplete="off"
							              v-model="form.transport_cost"></b-form-input>
						</b-input-group>
					</div>
				</div>

				<div class="row mb-2">
					<div class="col">{{ $t('sellerCost.valuationCost') }}</div>
					<div class="col-lg-4 col-md-6 col-sm-12">
						<b-input-group>
							<b-input-group-prepend is-text><i class="fas fa-euro-sign fa-fw"></i></b-input-group-prepend>
							<b-form-input type="number"
							              step="any"
							              class="text-right"
										  autocomplete="off"
							              v-model="form.valuation_cost"></b-form-input>
						</b-input-group>
					</div>
				</div>

				<div class="row mb-2">
					<div class="col">{{ $t('sellerCost.inspectionCost') }}</div>
					<div class="col-lg-4 col-md-6 col-sm-12">
						<b-input-group>
							<b-input-group-prepend is-text><i class="fas fa-euro-sign fa-fw"></i></b-input-group-prepend>
							<b-form-input type="number"
							              step="any"
							              class="text-right"
										  autocomplete="off"
							              v-model="form.inspection_cost"></b-form-input>
						</b-input-group>
					</div>
				</div>

				<div class="row mb-2">
					<div class="col">{{ $t('sellerCost.restorationCost') }}</div>
					<div class="col-lg-4 col-md-6 col-sm-12">
						<b-input-group>
							<b-input-group-prepend is-text><i class="fas fa-euro-sign fa-fw"></i></b-input-group-prepend>
							<b-form-input type="number"
							              step="any"
							              class="text-right"
										  autocomplete="off"
							              v-model="form.restoration_cost"></b-form-input>
						</b-input-group>
					</div>
				</div>

				<div class="row mb-2">
					<div class="col">{{ $t('sellerCost.fixedCommissionPercentage') }}</div>
					<div class="col-lg-4 col-md-6 col-sm-12">
						<b-input-group>
							<b-input-group-prepend is-text><i class="fas fa-percentage fa-fw"></i></b-input-group-prepend>
							<b-form-input type="number"
										  step="any"
							              class="text-right"
										  autocomplete="off"
							              v-model="form.fixed_commission_percentage"></b-form-input>
						</b-input-group>
					</div>
				</div>

				<div class="row mb-2">
					<div class="col">{{ $t('sellerCost.fixedPhotoCost') }}</div>
					<div class="col-lg-4 col-md-6 col-sm-12">
						<b-input-group>
							<b-input-group-prepend is-text><i class="fas fa-euro-sign fa-fw"></i></b-input-group-prepend>
							<b-form-input type="number"
							              step="any"
							              class="text-right"
										  autocomplete="off"
							              v-model="form.fixed_photo_cost"></b-form-input>
						</b-input-group>
					</div>
				</div>
				
				<div class="row mb-2">
					<div class="col">{{ $t('sellerCost.photoCost') }}</div>
					<div class="col-lg-4 col-md-6 col-sm-12">
						<b-input-group>
							<b-input-group-prepend is-text><i class="fas fa-euro-sign fa-fw"></i></b-input-group-prepend>
							<b-form-input type="number"
							              class="text-right"
							              disabled
							              :value="Number(costs.photo_cost).toFixed(2)"></b-form-input>
						</b-input-group>
					</div>
				</div>

				<div class="row mb-2">
					<div class="col">{{ $t('sellerCost.income') }}</div>
					<div class="col-lg-4 col-md-6 col-sm-12">
						<b-input-group>
							<b-input-group-prepend is-text><i class="fas fa-euro-sign fa-fw"></i></b-input-group-prepend>
							<b-form-input type="number"
							              class="text-right"
							              disabled
							              :value="Number(costs.income).toFixed(2)"></b-form-input>
						</b-input-group>
					</div>
				</div>

				<div class="row mb-2">
					<div class="col">{{ $t('sellerCost.commission') }}
						<small v-if="costs.item_count > 0">({{ Number(costs.commission_percentage).toFixed(2) }}%)</small>
					</div>
					<div class="col-lg-4 col-md-6 col-sm-12">
						<b-input-group>
							<b-input-group-prepend is-text><i class="fas fa-euro-sign fa-fw"></i></b-input-group-prepend>
							<b-form-input type="number"
							              class="text-right"
							              disabled
							              :value="Number(costs.commission).toFixed(2)"></b-form-input>
						</b-input-group>
					</div>
				</div>

				<div class="row mb-2">
					<div class="col">{{ $t('sellerCost.total') }}</div>
					<div class="col-lg-4 col-md-6 col-sm-12">
						<b-input-group>
							<b-input-group-prepend is-text><i class="fas fa-euro-sign fa-fw"></i></b-input-group-prepend>
							<b-form-input type="number"
							              class="text-right"
							              disabled
							              :value="Number(costs.total_cost).toFixed(2)"></b-form-input>
						</b-input-group>
					</div>
				</div>

				<hr />

				<div class="row mb-2">
					<div class="col">
						<h5>{{ $t('sellerCost.toPayout') }}</h5>
					</div>
					<div class="col-lg-4 col-md-6 col-sm-12">
						<h5 class="text-right">{{ costs.total_payout | currency }}</h5>
					</div>
				</div>

				<div class="row mb-2">
					<div class="col">{{ $t('sellerCost.payoutBank') }}</div>
					<div class="col-lg-4 col-md-6 col-sm-12">
						<b-input-group>
							<b-input-group-prepend is-text><i class="fas fa-euro-sign fa-fw"></i></b-input-group-prepend>
							<b-form-input type="number"
							              step="any"
							              class="text-right"
										  autocomplete="off"
							              v-model="form.payment_bank"></b-form-input>
						</b-input-group>
					</div>
				</div>

				<div class="row mb-2">
					<div class="col">{{ $t('sellerCost.payoutCash') }}</div>
					<div class="col-lg-4 col-md-6 col-sm-12">
						<b-input-group>
							<b-input-group-prepend is-text><i class="fas fa-euro-sign fa-fw"></i></b-input-group-prepend>
							<b-form-input type="number"
							              step="any"
							              class="text-right"
										  autocomplete="off"
							              v-model="form.payment_cash"></b-form-input>
						</b-input-group>
					</div>
				</div>

				<div class="row mb-4">
					<div class="col">{{ $t('common.paidAt') }}</div>
					<div class="col-lg-4 col-md-6 col-sm-12">
						<b-form-input type="date"
						              class="text-right"
									  autocomplete="off"
						              v-model="form.payment_date"></b-form-input>
					</div>
				</div>

				<b-btn class="pull-right"
				       type="submit"
				       variant="primary"
				       v-b-tooltip.hover
				       :title="$t('common.save')"><i class="fa fa-fw fa-save"></i></b-btn>
			</b-form>
		</div>

		<div class="col-sm-12"
		     v-if="!isFetching">
			<hr class="my-4" />
			<h3>{{ $t('common.report') }}</h3>
			<b-form @submit.prevent="downloadInvoice">

				<div class="row">
					<div class="col-md-6">
						<b-form-group :label="$t('common.date')">
							<b-form-input type="date"
										  autocomplete="off"
							              v-model="invoiceForm.date">
							</b-form-input>
						</b-form-group>

						<b-form-group :label="$t('common.invoiceType')">
							<b-form-select v-model="invoiceForm.type"
							               :options="options">
							</b-form-select>
						</b-form-group>
					</div>

					<div class="col-md-6">
						<b-form-group :label="$t('sellerCost.note')">
							<b-form-textarea v-model="invoiceForm.note"
							                 :rows="6"
							                 :max-rows="6">
							</b-form-textarea>
						</b-form-group>
					</div>

					<div class="col-12">

						<b-btn-group class="pull-right">
							<b-btn variant="primary"
							       v-b-tooltip.hover
							       v-bind:disabled="isEmailing"
							       @click="emailInvoiceModal"
							       :title="$t('common.emailInvoice')">
								<fa-icon icon="envelope"
								         fixed-width />
							</b-btn>
							<loader-button variant="primary"
								v-b-tooltip.hover
								type="submit"
								:title="$t('common.downloadReport')"
								iconName="file-pdf"
								:loading="isDownloading"
							/>
						</b-btn-group>

						<modal ref="emailModal"
						       size="lg"
						       :title="`${$t('common.emailInvoice')} '${options.find(v=> v.value == invoiceForm.type).text}'`">

							<div slot="modal-body">
								<div class="row">
									<div class="col">
										<b-form-textarea v-model="invoiceForm.email_text"
										                 :rows="6"
										                 :max-rows="6">
										</b-form-textarea>
									</div>
								</div>
							</div>
							<div slot="modal-footer">
								<div class="row">
									<div class="col">
										<b-button class="mt-3"
										          type="button"
										          variant="outline-primary"
										          block
										          @click="cancelEmailInvoiceModal">{{ $t('common.cancel') }}</b-button>
									</div>
									<div class="col">
										<b-button class="mt-3"
										          type="button"
										          v-bind:disabled="isEmailing"
										          block
										          variant="primary"
										          @click="emailInvoice">

											<loader-spinner :text="$t('common.emailInvoice')"
											                :show-spinner="isEmailing"></loader-spinner>

										</b-button>
									</div>
								</div>
							</div>
						</modal>

					</div>
				</div>

			</b-form>
		</div>

		<div class="col-sm-12" v-if="!isFetching">
			<hr class="my-4" />
			<h3 class="display-4">{{ $t('common.emailLogs') }}</h3>

			<email-logs-component
				:isFetching="isFetching"
				:logs="costs.email_logs"
			/>
		</div>
	</div>
</div>
</template>

<script>
import { isNil, pick, keys } from 'lodash';
import PersonService from '@/services/person-service.js';
import InvoiceService from '@/services/invoice-service.js';
import PartialLoader from '@/components/elements/PartialLoader';
import { flashSuccess } from '@/helpers/flash-message-helper';
import { isCancel, CancelToken } from 'axios';
import { currency } from '@/filters/number-filter';
import moment from 'moment';
import { smallDate, formatDate } from '@/filters/date-filters';
import Modal from '@/components/elements/Base/BaseDialogModal';
import LoaderSpinner from '@/components/elements/LoaderSpinner';
import { mapGetters } from 'vuex';
import EmailLogsComponent from '../../../elements/EmailLogsComponent';

export default {
	components: {
		PartialLoader,
		Modal,
		LoaderSpinner,
		EmailLogsComponent
	},
	filters: {
		currency,
		smallDate
	},
	data() {
		return {
			isDownloading: false,
			isFetching: true,
			isEmailing: false,
			costs: false,
			form: {
				fixed_commission_percentage: null,
				transport_cost: '0.00',
				valuation_cost: '0.00',
				inspection_cost: '0.00',
				restoration_cost: '0.00',
				fixed_photo_cost: null,
				payment_bank: '0.00',
				payment_cash: '0.00',
				payment_date: null
			},
			invoiceForm: false,
			options: [
				{ value: 'overview', text: 'Ingebrachte goederen' },
				{ value: 'unsold', text: 'Niet verkochte goederen' },
				{ value: 'sold', text: 'Verkochte goederen' },
				{ value: 'sold-paid', text: 'Verkochte goederen, betaald' },
				{ value: 'sold-unpaid', text: 'Verkochte goederen, niet betaald' }
			],
			error: false,
			formError: false
		}
	},
	computed: {
		...mapGetters([
			'activeAuction'
		])
	},
	watch: {
		activeAuction() {
			this.init();
		},
		costs() {
			this.form.fixed_commission_percentage = (this.costs.fixed_commission_percentage !== null) ? this.costs.fixed_commission_percentage : Number(20).toFixed(4);
			this.form.fixed_photo_cost = (this.costs.fixed_photo_cost !== null) ? this.costs.fixed_photo_cost : Number(5).toFixed(2);
			this.form.transport_cost = Number(this.costs.transport_cost).toFixed(2);
			this.form.valuation_cost = Number(this.costs.valuation_cost).toFixed(2);
			this.form.inspection_cost = Number(this.costs.inspection_cost).toFixed(2);
			this.form.restoration_cost = Number(this.costs.restoration_cost).toFixed(2);
			this.form.photo_cost = Number(this.costs.fixed_photo_cost * this.costs.item_count).toFixed(2);
			this.form.payment_bank = Number(this.costs.payment_bank).toFixed(2);
			this.form.payment_cash = Number(this.costs.payment_cash).toFixed(2);
		
			if (!isNil(this.form.payment_date))
				this.form.payment_date = formatDate(this.costs.payment_date, 'YYYY-MM-DD');
		},
	},
	methods: {
		fetchData() {
			this.error = false;
			this.isFetching = true;

			return PersonService.getSellerCost(this.$route.params.auctionId, this.$route.params.personId).then(response => {
				this.isFetching = false;
				this.costs = response;
				this.costs.photo_cost = response.item_count * response.fixed_photo_cost
			}).catch(error => {
				if (!isCancel(error)) {
					this.isFetching = false;
					this.error = error.message;
				}
			});
		},
		save(event) {
			this.formError = false;
			this.isFetching = true;
			const post = this.form;

			if (post.photo_cost == this.costs.photo_cost) {
				delete post.photo_cost;
			}
		
			return PersonService.updateSellerCost(this.$route.params.auctionId, this.$route.params.personId, post).then(response => {
				this.fetchData().then(() => flashSuccess(this.$t('sellerCost.updateSuccess')));
			}).catch(error => {
				this.isFetching = false;
				this.formError = error.response.data;
			});
		},
		async downloadInvoice() {
			this.isDownloading = true;

			try {
				const response = await InvoiceService.getSellerInvoiceUrl(this.$route.params.auctionId, this.$route.params.personId, this.invoiceForm);	

				const data = window.URL.createObjectURL(response);
				const dateString = `${(new Date()).toLocaleDateString('nl', { year:'numeric', month:'numeric', day:'numeric' })}`
				let aTag = document.createElement('a');
				
				aTag.href = data;
				aTag.download = `Factuur ODB ${dateString}.pdf`;
				aTag.style = "position: absolute; opacity: 0;";
				aTag.target = '_blank';
				
				document.body.appendChild(aTag);
				aTag.click();

				setTimeout(function () {
					document.body.removeChild(aTag);
					window.URL.revokeObjectURL(data);
				}, 100);

				this.isDownloading = false;
			}
			catch (error) {
				this.isDownloading = false;

				throw error;
			}
		},
		emailInvoiceModal() {
			this.$refs.emailModal.show();
			return false;
		},
		cancelEmailInvoiceModal() {
			this.invoiceForm.email_text = this.activeAuction.seller_invoice_email_text;
			this.$refs.emailModal.hide();
		},
		emailInvoice() {
			this.isEmailing = true;
			const params = this.invoiceForm;
			params.email = 1;

			InvoiceService.emailSellerInvoice(this.$route.params.auctionId, this.$route.params.personId, params).then(response => {
				flashSuccess(this.$t('common.emailSend'));
				this.isEmailing = false;
				this.invoiceForm.email = 0;
				this.cancelEmailInvoiceModal();
			}).catch(error => {
				this.isEmailing = false;
				this.invoiceForm.email = 0;
				this.formError = error.response.data;
			});
		},
		initInvoiceForm() {
			this.invoiceForm = {
				date: moment().format('YYYY-MM-DD'),
				note: '',
				type: 'overview',
				email_text: this.activeAuction.seller_invoice_email_text
			};
		},
		init() {
			this.fetchData();
			this.initInvoiceForm();
		}
	},
	mounted() {

	}
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// SellerCost.vue?44dbf358